import {Component} from "react";
import styles from './SliderShow.module.scss';
import {Typography} from "@material-ui/core";
import i18n from "../../i18n";
import {LocaleService} from "../../common/LocaleService";

// Vite resuelve estas imagenes en tiempo de build. Sustituye al require()
// dinamico de webpack, que Vite no soporta. Las claves del mapa son las rutas
// relativas tal cual aparecen en el patron.
const slideImages = import.meta.glob('../../assets/slides/*/img*.jpg', {
    eager: true,
    query: '?url',
    import: 'default',
}) as Record<string, string>;

/**
 * Resuelve la URL de la imagen de un slide para el idioma activo.
 *
 * @param imageName Nombre del archivo, por ejemplo 'img001.jpg'.
 * @return URL de la imagen, o undefined si no existe.
 */
function slideImage(imageName: string): string | undefined {
    const lang = LocaleService.getLanguage();
    return slideImages[`../../assets/slides/${lang}/${imageName}`];
}


export class Slide1 extends Component {
    render() {
        const imagePath = slideImage('img001.jpg');

        return <div className={styles.slide}>
            <img src={imagePath} alt={ i18n.t('initialCard.slide1Alt') } />
            <p>
                { i18n.t('initialCard.slide1') }
            </p>
        </div>
    }
}

export class Slide2 extends Component {
    render() {
        const imagePath = slideImage('img002.jpg');
        return <div className={styles.slide}>
            <img src={imagePath} alt={ i18n.t('initialCard.slide1Alt') } />
            <p>
                { i18n.t('initialCard.slide2') }
            </p>
        </div>
    }
}

export class Slide3 extends Component {
    render() {
        const imagePath = slideImage('img003.jpg');
        return <div className={styles.slide}>
            <img src={imagePath} alt={ i18n.t('initialCard.slide3Alt') } />
            <p>
                { i18n.t('initialCard.slide3') }
            </p>
        </div>
    }
}

export class Slide4 extends Component {
    render() {
        const imagePath = slideImage('img004.jpg');
        return <div className={styles.slide}>
            <img src={imagePath} alt={ i18n.t('initialCard.slide4Alt') } />
            <p>
                { i18n.t('initialCard.slide4') }
            </p>
        </div>
    }
}

export class Slide5 extends Component {
    render() {
        const imagePath = slideImage('img005.jpg');
        return <div className={styles.slide}>
            <img src={imagePath} alt={ i18n.t('initialCard.slide5Alt') } />
            <p>
                { i18n.t('initialCard.slide5') }
            </p>
        </div>
    }
}

export class Slide6 extends Component {
    render() {
        return <div className={styles.slide}>
            <div className={styles.logo}>
                <div className="logo active logo-maps" />
            </div>

            <Typography variant="h3" component="h3">
                { i18n.t('initialCard.end') }
            </Typography>
        </div>
    }
}
